import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { get } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import Slider from "react-slick";

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const Banner = () => {
    const [bannerData, setBannerData] = useState([]);
    const [error, setError] = useState();
    const [loading, setLoading] = useState();


    const GetProductOffer = async () => {
        setLoading(true);
        try {
            const response = await get(API_URL.banners);
            setBannerData(response || []);
        } catch (error) {
            setError("Data Not Avaiable");
        } finally {
            setLoading(false);
        }
    };
  

    useEffect(() => {
        GetProductOffer();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        loop:true
    };

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <div>
            {error ? (
                <div className="container search_page_not_data">
                    <div className="error_image row justify-content-center">
                        <img src="./images/error1.png" alt="" className="col-lg-5 col-md-6 col-10" />
                    </div>
                </div>
            ) : bannerData?.length > 0 ? (
                bannerData.length === 1 ? (
                    bannerData.map((banner, index) => (
                        <div key={index}>
                            <div className="banner_wepper desktop_banner">
                                <a href={banner?.url || "#"}>
                                    <img src={banner?.photo_full_url} alt="banner" className="w-100" />
                                </a>
                            </div>
                            <div className="banner_wepper mobile_banner">
                                <a href={banner?.url || "#"}>
                                    <img src={banner?.photo_full_url} alt="banner" className="w-100" />
                                </a>
                            </div>
                        </div>
                    ))
                ) : (
                    <Slider {...settings}>
                        {bannerData.map((banner, index) => (
                            <div key={index}>
                                <div className="banner_wepper desktop_banner">
                                    <a href={banner?.url || "#"}>
                                        <img src={banner?.photo_full_url} alt="banner" className="w-100" />
                                    </a>
                                </div>
                                <div className="banner_wepper mobile_banner">
                                    <a href={banner?.url || "#"}>
                                        <img src={banner?.photo_full_url} alt="banner" className="w-100" />
                                    </a>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )
            ) : (
                <div className="container search_page_not_data">
                    <div className="error_image row justify-content-center">
                        <img src="./images/error1.png" alt="" className="col-lg-5 col-md-6 col-10" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Banner;